import { render, staticRenderFns } from "./PersonalInfoBody.vue?vue&type=template&id=65bfdcfa&"
import script from "./PersonalInfoBody.vue?vue&type=script&lang=js&"
export * from "./PersonalInfoBody.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports